import classNames from 'classnames';
import React, { CSSProperties } from 'react';

import { IStyledProps, useStyles } from './styles';

const [, ...DOTS] = [...Array(6).keys()];

interface ISpinner extends IStyledProps {
  big?: boolean;
  style?: CSSProperties;
}

export const Spinner: React.FC<ISpinner> = ({ big, style, ...styledProps }) => {
  const classes = useStyles(styledProps);

  return (
    <div
      className={classNames(classes.spinner, {
        [classes.big]: big,
      })}
      style={style}
    >
      {DOTS.map((i) => (
        <div
          key={i}
          className={classNames(classes.bounce, classes.animation, (classes as any)[`dot${i}`])}
        />
      ))}
    </div>
  );
};
